import React from 'react';
import './Payout.css';
import CurrencyFormat from 'react-currency-format';
import { Link} from "react-router-dom";



class Payout extends React.Component {

//   constructor(props) {
//     super(props);
//     this.savetolocal = this.savetolocal.bind(this);
//   }

//   savetolocal (e) {
//     localStorage.setItem('count',this.props.count)
//     localStorage.setItem('cartProducts',JSON.stringify(this.props.cartProducts))
//   }
    render () {
      return (
        <div>
          {this.props.totalPrice !== 0 ? (
            <Link to="/bayar">
              <div className="payout shadow">
                <span>
                  <i className="fa fa-shopping-cart" aria-hidden="true"></i>
                  &nbsp;Bayar (
                  <CurrencyFormat
                    value={this.props.totalPrice}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={"Rp "}
                  />
                  )
                </span>
              </div>
            </Link>
          ) : (
            ""
          )}
          <Link to="/beli">
            <div className="payoutBack shadow">
              <span>
                <i className="fa fa-arrow-left" aria-hidden="true"></i>
                &nbsp;Kembali
              </span>
            </div>
          </Link>
        </div>
      );
    }
  }


export default Payout;
